import { useEffect, useState, useRef } from 'react'

const FIVE_MINUTES = 300000

/**
 * Hook for seeing if the use is idle
 *
 * @param idleTime the time to determine if use is idle, defaulted to 5 mins
 */
export const useIdle = (idleTime = FIVE_MINUTES): boolean => {
    const [isIdle, setIsIdle] = useState(false)
    // since we don't want to rerender on each user event changes we use useRef
    const timeoutRef = useRef(null)

    const resetTimer = () => {
        clearTimeout(timeoutRef.current)
        setIsIdle(false)
        timeoutRef.current = setTimeout(() => setIsIdle(true), idleTime)
    }

    useEffect(() => {
        // Attach event listeners to detect user activity
        window.addEventListener('mousemove', resetTimer)
        window.addEventListener('keydown', resetTimer)
        window.addEventListener('wheel', resetTimer)
        window.addEventListener('mousedown', resetTimer)
        window.addEventListener('touchstart', resetTimer)
        window.addEventListener('touchmove', resetTimer)

        resetTimer() // Start the timer initially

        return () => {
            // Clean up event listeners on unmount
            clearTimeout(timeoutRef.current)
            window.removeEventListener('mousemove', resetTimer)
            window.removeEventListener('keydown', resetTimer)
            window.removeEventListener('wheel', resetTimer)
            window.removeEventListener('mousedown', resetTimer)
            window.removeEventListener('touchstart', resetTimer)
            window.removeEventListener('touchmove', resetTimer)
        }
    }, [idleTime])

    return isIdle
}
